import Card from "components/common/Card";
import React, { useEffect, useState } from "react";
import reviewImg from "assets/icons/review.svg";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { useParams } from "react-router-dom";
import { getMotorReviewData, submitReviewData } from "store/thunk/kyp.thunk";
import { useFormik } from "formik";
import Motortabs from "./components/Motortabs";
import MotortabDetails from "./components/MotortabDetails";
import Button from "components/semantic/Button";
import ResultCountDown from "pages/ReviewPolicy/component/ResultCountDown";
import { ALL_POLICY_TYPES } from "utils/utils";

const MotorReview = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [showCountDown, setShowCountDown] = useState(false);

  const dispatch = useAppDispatch();
  const param: any = useParams();

  const hasNoError = (obj: any) => {
    if (typeof obj !== "object" || obj === null) return false;

    for (const key in obj) {
      const value = obj[key];

      if (!Array.isArray(value) && key !== "") return true;

      if (Array.isArray(value)) {
        for (const item of value) {
          if (hasNoError(item)) return true;
        }
      } else if (typeof value === "object") {
        if (hasNoError(value)) return true;
      }
    }

    return false;
  };

  const handleNavigate = () => {
    if (activeTab === 2) handleSubmit();
    else setActiveTab(activeTab + 1);
  };

  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.motorReviewData);
  const isSubmitting = useAppSelector((state) => state.rootReducer.kypSlice.motorSubmitLoading);

  useEffect(() => {
    dispatch(getMotorReviewData(param?.policyId));
  }, [dispatch, param]);

  const { values, initialValues, touched, errors, handleSubmit, setFieldValue, setFieldError }: any = useFormik({
    initialValues: {
      insuredDetails: policyData?.reviewScreenData?.insuredDetails,
      nomineeDetails: policyData?.reviewScreenData?.nomineeDetails,
      vehicleDetails: policyData?.reviewScreenData?.vehicleDetails
    },
    enableReinitialize: true,
    onSubmit: async (values: any) => {
      const payload = {
        policyId: param?.policyId,
        userInput: values
      };
      dispatch(submitReviewData(payload))
        .unwrap()
        .then((data) => {
          if (data?.success) {
            setShowCountDown(true);
          }
        });
    }
  });

  const formProps = { values, initialValues, touched, errors, setFieldError, setFieldValue };

  return (
    <>
      <h1 className="text-lg md:text-2xl font-extrabold text-gray-800 mb-4">Policyholder & Insured Preview</h1>
      <Card className="w-full" parentClassName="mb-7">
        <div className="flex items-center gap-2 py-3 px-4 border-b-[1px] w-full border-border-color">
          <img src={reviewImg} />

          <p className="font-medium h-full text-[13px] md:text-base">
            Review your policy details and click <span className="font-bold">'Edit'</span> to make corrections. We'll assist you in informing your insurance company.
          </p>
        </div>
        <Motortabs activeTab={activeTab} setActiveTab={setActiveTab} />

        {activeTab === 0 && <MotortabDetails id="insuredDetails" formProps={formProps} />}
        {activeTab === 1 && <MotortabDetails id="nomineeDetails" formProps={formProps} />}
        {activeTab === 2 && <MotortabDetails id="vehicleDetails" formProps={formProps} />}
        <div className={`hidden md:flex justify-center items-center py-4 border-t-[1px] border-border-color mt-10 `}>
          <Button title="NEXT" isLoading={isSubmitting} onClick={handleNavigate} className={`${hasNoError(errors) || (isSubmitting && "opacity-50 pointer-events-none")}`} />
        </div>
      </Card>
      <Card className={`w-full fixed bottom-0 left-0 rounded-t-[15px] bg-white flex justify-center py-5 ${isSubmitting && "opacity-50 pointer-events-none"}`} parentClassName={` shadow-none flex md:hidden `}>
        <Button title="NEXT" isLoading={isSubmitting} onClick={handleNavigate} className={`${hasNoError(errors) && "opacity-50 pointer-events-none"}`} />
      </Card>
      {showCountDown && <ResultCountDown policyId={param?.policyId} policyTypeId={ALL_POLICY_TYPES.MOTOR} />}
    </>
  );
};

export default MotorReview;
